import VideoResult from "../modules/video-result";
import MoreLinks from "../modules/more-links";

const $ = require('jquery');

class DocumentsPage {
  constructor(root) {
    this.container = root;
    this.initAccordions();
    this.initFilters();
    this.initVideoResults();
    this.initClosingCards();
    this.filtersCount();
  }

  initClosingCards() {
    this.cardsContainer = this.container.querySelector('.more-links');
    if(this.cardsContainer) {
      this.moreLinks = new MoreLinks(this.cardsContainer);
    }
  }

  resetFilters() {
    var that = this;
    var allFilter = $('.documents__filters-checkbox[data-filter-val="all"]');

    // Uncheck all inputs
    $('.documents__filters-checkbox ').removeClass('checked');
    $('input[type="checkbox"]').prop('checked', false);
    $('input[type="checkbox"]')
    // Check the 'all' input
    allFilter.addClass('checked');
    allFilter.find('input').prop('checked', true);

    // Clear out the filterObj
    Object.entries(this.filterObj).forEach(([key]) => {
      if(key !== 'cagegory') {
        that.filterObj[key] = [];
      }
    });
  }

  applyFilters() {
    // Construct target URL
    var targetUrl = window.location.href.split('?')[0];
    var queryParams = '';

    // Build the query string based on the filter object
    Object.entries(this.filterObj).forEach(([key, value]) => {
      if(value.length) {
        queryParams += (queryParams === '') ? '?' : '&';
        queryParams += key + '=' + value.toString();
      }
    });

    // Initiate redirect
    window.location.href = targetUrl + queryParams;
  }

  initFilters() {
    var that = this;

    // Set up the filter object - this stores all currently checked values
    this.filterObj = {
      'sort': [],
      'type': [],
      'item': [],
      'category': [],
      'paged': [1]
    };

    $('.documents__filters__name').each(function() {
      that.filterObj[$(this).attr('data-filter-slug')] = [];
    });

    // Add any currently checked items
    $('.documents__filters-checkbox  input:checked').each(function() {
      if($(this).val() !== 'all') {
        that.filterObj[$(this).attr('name')].push($(this).val());
      }
    });

    // Attach click event to checkboxes
    $('.documents__filters-checkbox ').click(function(e) {
      e.preventDefault();

      const clickedItem = $(this);
      // Allow only one filtered between All, PDF, and Videos
      if ($(this).find('input').prop('name') === 'type') {
        const input = $($(this).find('input'));
        $('input[name="type"]').prop('checked', false);
        $('input[name="type"]').parent().removeClass('checked');
        if (input.prop('checked') === true) {
          $('[data-filter-val="all"]').addClass('checked');
          $('[data-filter-val="all"]').find('input').prop('checked', true);
        } else {
          clickedItem.addClass('checked');
          clickedItem.find('input').prop('checked', true);
        }

        // Remove the current filter in the filterObj.
        // Push it into the type array.
        that.filterObj[input.attr('name')].splice(that.filterObj[input.attr('name')].indexOf(input.val()),1);
        if (input.attr('value') !== 'all') { // All doesn't need a query arg
          that.filterObj[input.attr('name')].push(input.val());
        }

      // Allow only one Category filter
      } else if ($(this).find('input').prop('name') === 'category') {
        const input = $($(this).find('input'));
        // Remove if active
        if (input.prop('checked') === true) {
          $('input[name="category"]').prop('checked', false);
          $('input[name="category"]').parent().removeClass('active');
          that.filterObj[input.attr('name')].splice(that.filterObj[input.attr('name')].indexOf(input.val()),1);
        // Add clicked item
        } else {
          $('input[name="category"]').prop('checked', false);
          $('input[name="category"]').parent().removeClass('active');
          clickedItem.addClass('active');
          clickedItem.find('input').prop('checked', true);
          that.filterObj[input.attr('name')].splice(that.filterObj[input.attr('name')].indexOf(input.val()),1);
          that.filterObj[input.attr('name')].push(input.val());
        }
        // Force the filter be apllied
        $('.gallery-filter__apply').click();

        // Allow only one Sort filter
      } else if ($(this).find('input').prop('name') === 'sort') {
        const input = $($(this).find('input'));
        // Remove if active
        if (input.prop('checked') === true) {
          $('input[name="sort"]').prop('checked', false);
          $('input[name="sort"]').parent().removeClass('active');
          that.filterObj[input.attr('name')].splice(that.filterObj[input.attr('name')].indexOf(input.val()),1);
        // Add clicked item
        } else {
          $('input[name="sort"]').prop('checked', false);
          $('input[name="sort"]').parent().removeClass('active');
          clickedItem.addClass('active');
          clickedItem.find('input').prop('checked', true);
          that.filterObj[input.attr('name')].splice(that.filterObj[input.attr('name')].indexOf(input.val()),1);
          that.filterObj[input.attr('name')].push(input.val());
        }
        // Force the filter be apllied
        $('.gallery-filter__apply').click();


      // Product filtering
      } else {
        // Toggle the checked class and property on the input
        $(this).toggleClass('checked');
        var checked = $(this).hasClass('checked');
        const input = $($(this).find('input'));
        input.prop('checked', checked);


        if(that.filterObj[input.attr('name')].includes(input.val())) {
          that.filterObj[input.attr('name')].splice(that.filterObj[input.attr('name')].indexOf(input.val()),1);
        } else {
          that.filterObj[input.attr('name')].push(input.val());
        }
      }

    });

    // Attach click to reset button
    $('.gallery-filter__reset').click(function(e) {
      e.preventDefault();
      that.resetFilters();
    });

    // Attach click to apply button
    $('.gallery-filter__apply').click(function(e) {
      e.preventDefault();
      that.applyFilters();
    });

    // When a filter name is clicked, we should expand/collapse it
    $('.filters-group__name').click(function() {
      // The filter is actually the parent
      var filterGroup = $(this).parent();

      filterGroup.toggleClass('expanded');
      filterGroup.find('.filters-group__checkboxes').slideToggle(300);
    });

    // Attach open event to show-mobile-filters
    $('.documents__filters--button').click(function() {
      $('body').addClass('modal--open');
      $('.documents__content').addClass('filters--open');
      $('form.documents__filters').addClass('open');
    });

    // Attach close event for mobile filters
    $('.gallery-filters__close').click(function(e) {
      e.preventDefault();
      $('body').removeClass('modal--open');
      $('body').css({'position': '', 'top': ''});
      $('.documents__content').removeClass('filters--open');
      $('form.documents__filters').removeClass('open');
    });

    // Only expand the last/shingles section by default
    var lastFilter = $('.filters-group--expandable').last();
    lastFilter.addClass('expanded');
    lastFilter.find('.filters-group__checkboxes').slideToggle(0);
  }


  initAccordions() {
    this.accordions = $('.category');

    this.accordions.each(function(idx) {
      if (idx === 0) {
          $(this).parent().addClass('open');
          $(this).parent().find('.accordion-wrap').slideToggle();
      }
      $(this).click(function() {
        $(this).parent().toggleClass('open'); // Flip arrow
        const content = $(this).parent().find('.accordion-wrap');
        content.slideToggle();

      });
    });

  }
  initVideoResults() {
    const results = this.container.querySelectorAll('.video-result');
    this.videoResults = [];

    const instance = this;
    results.forEach(result => {
        instance.videoResults.push(new VideoResult(result));
    });
  }

  // Add a counter to the filter header.
  filtersCount() {
    const filterGroups = this.container.querySelectorAll('.filters-group');
    filterGroups.forEach(group => {
      const checked = group.querySelectorAll('.checked');
      const count = checked.length;
      const countEl = group.querySelector('.filters-group__name span');
      if (countEl && count > 0) {
        countEl.innerHTML = count;
        countEl.classList.add('filters-group__count');
      }
    });
  }


}

export { DocumentsPage }
